<div class="page-container search-container container unified">
  <div class="content">
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    />
  </div>
</div>
